export default __webpack_public_path__ + "fa0e0f76eef2bd2c130a4fc7f702242f.png";